import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { mask } from 'remask';
import axios from 'axios';
import { UFS, CAMPO_OBRIGATORIO } from '../../consts/common';
import { isEmpty, isCepValid, replaceSpecialChars } from '../../utils/common';

function Clientes({ endereco, handleUpdateEndereco, handleAlert }) {
  const CEPPattern = ['99.999-999'];
  const [errorCep, setErrorCep] = useState(isEmpty(endereco.cep));
  const [errorLogradouro, setErrorLogradouro] = useState(
    isEmpty(endereco.logradouro)
  );
  const [errorNumero, setErrorNumero] = useState(isEmpty(endereco.numero));
  const [errorComplemento, setErrorComplemento] = useState(
    isEmpty(endereco.complemento)
  );
  const [errorBairro, setErrorBairro] = useState(isEmpty(endereco.bairro));
  const [errorCidade, setErrorCidade] = useState(isEmpty(endereco.cidade));
  const [errorEstado, setErrorEstado] = useState(isEmpty(endereco.estado));

  const isValid = ({
    ec = errorCep,
    el = errorLogradouro,
    en = errorNumero,
    eco = errorComplemento,
    eb = errorBairro,
    eci = errorCidade,
    ee = errorEstado,
  }) => !ec && !el && !en && !eco && !eb && !eci && !ee;

  const isError = (ef) => endereco.cep !== '' && ef;

  const handleChangeCepCliente = async (event) => {
    const obj = endereco;
    obj.cep = event.target.value;
    if (isCepValid(event.target.value)) {
      await axios
        .get(
          `https://viacep.com.br/ws/${event.target.value.replace(
            /\D/g,
            ''
          )}/json`
        )
        .then((res) => {
          obj.cep = res.data.cep.replace(/\D/g, '');
          obj.bairro = res.data.bairro;
          obj.complemento = res.data.complemento;
          obj.cidade = res.data.localidade;
          obj.logradouro = res.data.logradouro;
          obj.estado = res.data.uf;
          obj.ibge = res.data.ibge;
          obj.numero = '';
          setErrorCep(!isCepValid(obj.cep));
          setErrorLogradouro(isEmpty(obj.logradouro));
          setErrorNumero(isEmpty(obj.numero));
          setErrorComplemento(isEmpty(obj.complemento));
          setErrorBairro(isEmpty(obj.bairro));
          setErrorCidade(isEmpty(obj.cidade));
          setErrorEstado(isEmpty(obj.estado));
          handleUpdateEndereco(obj, isValid({}));
        })
        .catch((err) => {
          console.log(err);
          handleUpdateEndereco(obj, isValid({}));
          setErrorCep(false);
          handleAlert(true, 'warning', 'CEP não encontrado!');
        });
    } else {
      setErrorCep(true);
      handleUpdateEndereco(obj, false);
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TextField
          id="cep"
          label="CEP"
          variant="outlined"
          value={mask(endereco.cep, CEPPattern)}
          onChange={handleChangeCepCliente}
          error={isError(errorCep)}
          helperText={CAMPO_OBRIGATORIO}
          InputLabelProps={{
            shrink: true,
          }}
          placeholder="CEP"
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          id="logradouro"
          label="Logradouro"
          variant="outlined"
          value={endereco.logradouro}
          onChange={(event) => {
            const obj = endereco;
            obj.logradouro = replaceSpecialChars(event.target.value);
            handleUpdateEndereco(
              obj,
              isValid({
                el: isEmpty(obj.logradouro),
              })
            );
            setErrorLogradouro(isEmpty(obj.logradouro));
          }}
          InputLabelProps={{
            shrink: true,
          }}
          placeholder="Logradouro"
          error={isError(errorLogradouro)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          fullWidth
          id="numero"
          label="numero"
          variant="outlined"
          value={endereco.numero}
          onChange={(event) => {
            const obj = endereco;
            obj.numero = replaceSpecialChars(event.target.value);
            handleUpdateEndereco(
              obj,
              isValid({
                en: isEmpty(obj.numero),
              })
            );
            setErrorNumero(isEmpty(obj.numero));
          }}
          InputLabelProps={{
            shrink: true,
          }}
          placeholder="Número"
          error={isError(errorNumero)}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          id="complemento"
          label="Complemento"
          variant="outlined"
          value={endereco.complemento}
          onChange={(event) => {
            const obj = endereco;
            obj.complemento = replaceSpecialChars(event.target.value);
            handleUpdateEndereco(
              obj,
              isValid({
                eco: isEmpty(obj.complemento),
              })
            );
            setErrorComplemento(isEmpty(obj.complemento));
          }}
          InputLabelProps={{
            shrink: true,
          }}
          placeholder="Complemento"
          error={isError(errorComplemento)}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          id="bairro"
          label="Bairro"
          variant="outlined"
          value={endereco.bairro}
          onChange={(event) => {
            const obj = endereco;
            obj.bairro = replaceSpecialChars(event.target.value);
            handleUpdateEndereco(
              obj,
              isValid({
                eb: isEmpty(obj.bairro),
              })
            );
            setErrorBairro(isEmpty(obj.bairro));
          }}
          InputLabelProps={{
            shrink: true,
          }}
          placeholder="Bairro"
          error={isError(errorBairro)}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          id="cidade"
          label="Cidade"
          variant="outlined"
          value={endereco.cidade}
          onChange={(event) => {
            const obj = endereco;
            obj.cidade = replaceSpecialChars(event.target.value);
            handleUpdateEndereco(
              obj,
              isValid({
                eci: isEmpty(obj.cidade),
              })
            );
            setErrorCidade(isEmpty(obj.cidade));
          }}
          error={isError(errorCidade)}
          helperText={CAMPO_OBRIGATORIO}
          InputLabelProps={{
            shrink: true,
          }}
          placeholder="Cidade"
        />
      </Grid>
      <Grid item xs={2}>
        <TextField
          fullWidth
          id="estado"
          select
          label="Estado"
          variant="outlined"
          value={String(endereco.estado)}
          onChange={(event) => {
            const obj = endereco;
            obj.estado = replaceSpecialChars(event.target.value);
            handleUpdateEndereco(
              obj,
              isValid({
                ec: errorCep,
                eci: errorCidade,
                ee: isEmpty({
                  ee: isEmpty(obj.estado),
                }),
              })
            );
            setErrorEstado(isEmpty(obj.estado));
          }}
          error={isError(errorEstado)}
          helperText={CAMPO_OBRIGATORIO}
          InputLabelProps={{
            shrink: true,
          }}
          placeholder="Estado"
        >
          {UFS.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
  );
}

export default Clientes;
